import { render, staticRenderFns } from "./RedirectView.vue?vue&type=template&id=a02237ee&scoped=true"
import script from "./RedirectView.ts?vue&type=script&lang=ts&external"
export * from "./RedirectView.ts?vue&type=script&lang=ts&external"
import style0 from "./RedirectView.vue?vue&type=style&index=0&id=a02237ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a02237ee",
  null
  
)

export default component.exports